import { BaseProduct } from 'types';
import { computed } from 'mobx';
import { ProductChangeType, ProductCode } from 'enums';
import { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { RootStore } from 'providers';
import { Product } from '../../../Product';
import { AdvancedPlansProductModel } from 'models/AdvancedPlansProductModel';

export interface ProductHatProps extends InjectedExperimentsProps {
  rootStore: RootStore;
  product: Product | AdvancedPlansProductModel;
  isMobile?: boolean;
}
export class ProductHatController {
  constructor(private readonly props: ProductHatProps) {}
  /*
    The hat label logic is a following (by priority):
    1. In sale discount label.
    2. In second upgrade no label.
    3. Custom key from marketing data.
    4. Unlimeted plan will get most popular if none of the above applied.
    */

  @computed
  get hatKey() {
    const { rootStore, product } = this.props;
    const { isInSale } = rootStore.appStore;
    if (product.isCurrentPlanProduct) {
      return 'productEntry.current_plan.hat';
    }
    if (this.isNonUpgradeProduct()) {
      return '';
    }
    if (isInSale) {
      return product.isProductInSale || product.getfirstCycleYearlyMonthly()
        ? 'sale.product.x_off'
        : '';
    }

    if (product.getHatLabel()) {
      return product.getHatLabel() || '';
    }
    if (
      product.getCode() === ProductCode.WEBSITE_UNLIMITED &&
      !this.hatKeyProductExists()
    ) {
      return 'product.most_popular';
    }
    if (
      product.getCode() === ProductCode.BUSINESS_GROW &&
      !this.hatKeyProductExists()
    ) {
      return 'product.best_value';
    }
    if (
      product.getCode() === ProductCode.BUSINESS_UNLIMITED &&
      !this.hatKeyProductExists()
    ) {
      return 'product.most_popular';
    }
    return '';
  }

  @computed
  get hasLimitedTimeOfferData() {
    return !!this.props.product.getfirstCycleYearlyMonthly();
  }

  @computed
  get discoutPercentage() {
    const { product, rootStore } = this.props;
    const { isInSale } = rootStore.appStore;
    if (isInSale && product.isProductInSale) {
      const { discountPercent } = this.getSaleParams();
      return discountPercent || '50';
    }

    if (this.hasLimitedTimeOfferData) {
      return product.getDiscountPercent() || '20';
    }
  }

  hatKeyProductExists = () => {
    const { rootStore, product } = this.props;
    const type = product.getType();
    const products: BaseProduct[] =
      rootStore.appStore.appContext.advancedPlansProducts;

    return !!products
      .filter((p) => p.type === type && p.productCode !== product.getCode())
      .find((p) => !!p.hatKey);
  };

  getSaleParams = () => this.props.rootStore.appStore.appContext.saleParams;

  isNonUpgradeProduct = () => {
    const { rootStore, product } = this.props;
    const { isSwitchPlan } = rootStore.appStore;
    return (
      isSwitchPlan &&
      product.getProductChangeType() !== ProductChangeType.Upgrade
    );
  };
}
